/* eslint-disable arrow-body-style */
import { connect } from 'react-redux';
import GetStarted from '../../components/Blades/GetStarted/GetStarted';
import { visibilityActions } from '../../stores/visibility/visibilityActions';

const mapDispatchToProps = {
  completed: visibilityActions.bladeComplete,
};

export default connect(null, mapDispatchToProps)(GetStarted);
